import { render } from "./GrowthSelect.vue?vue&type=template&id=060449d4&scoped=true&ts=true"
import script from "./GrowthSelect.vue?vue&type=script&lang=ts"
export * from "./GrowthSelect.vue?vue&type=script&lang=ts"

import "./GrowthSelect.vue?vue&type=style&index=0&id=060449d4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-060449d4"]])

export default __exports__